export default "__VITE_ASSET__Dl1F81Tt__"